import { MenuItem } from '../types';
import DashboardSvg from 'Assets/icons/dashboard.svg';
import BusinessSvg from 'Assets/icons/business.svg';
import OperationsSvg from 'Assets/icons/operations.svg';
import WarehousingSvg from 'Assets/icons/warehousing.svg';
import ReportsSvg from 'Assets/icons/reports.svg';
import NetworkSvg from 'Assets/icons/new-network.svg';
import LeadsSvg from 'Assets/icons/people.svg';
import EstimatesSvg from 'Assets/icons/estimates.svg';
import ProposalSvg from 'Assets/icons/proposal.svg';
import ContactsSvg from 'Assets/icons/contacts.svg';
import CustomersSvg from 'Assets/icons/user.svg';
import SuppliersSvg from 'Assets/icons/suppliers.svg';
import SubcontractosSvg from 'Assets/icons/subcontractors.svg';
import InvoicingSvg from 'Assets/icons/invoicing.svg';
import CreditNotesSvg from 'Assets/icons/credit-notes.svg';
import ExpensesSvg from 'Assets/icons/expenses.svg';
import OrdersSvg from 'Assets/icons/orders.svg';
import DispatchSvg from 'Assets/icons/dispatch.svg';
import BookingsSvg from 'Assets/icons/bookings.svg';
import ShipmentsSvg from 'Assets/icons/shipments.svg';
import ClaimsSvg from 'Assets/icons/claims.svg';
import StorageBoxUnitSvg from 'Assets/icons/storage-box-unit.svg';
import MovementsSvg from 'Assets/icons/movements.svg';
import TransshipmentSvg from 'Assets/icons/transshipment.svg';
import StorageAccountSvg from 'Assets/icons/storage-account.svg';
import FavoritesSvg from 'Assets/icons/favorite.svg';
import ManagementSvg from 'Assets/icons/management.svg';
import FinanceSvg from 'Assets/icons/finance.svg';
import BussinesReportsSvg from 'Assets/icons/business-reports.svg';
import OperationsReportsSvg from 'Assets/icons/operations-reports.svg';
import { ResourcePageEnum } from 'Util/enums/resourcePage';
import { PRIVATE_ROUTES } from 'Constants';

export type NavUI = 'accordion' | 'drawer' | 'third-drawer';

export const menuConfigMain: MenuItem[] = [
  { key: 'dashboard', label: 'dashboard', icon: DashboardSvg, path: PRIVATE_ROUTES.OVERVIEW_MAIN },

  {
    key: 'business',
    label: 'business',
    ui: 'accordion',
    icon: BusinessSvg,
    children: [
      { key: 'leads', label: 'leads', icon: LeadsSvg, path: PRIVATE_ROUTES.LEADS },
      { key: 'quote', label: 'estimates', icon: EstimatesSvg, path: PRIVATE_ROUTES.QUOTES },
      { key: 'proposal', label: 'proposal', icon: ProposalSvg, path: PRIVATE_ROUTES.PROPOSAL },
      {
        key: 'contacts',
        label: 'contacts',
        icon: ContactsSvg,
        sectionTitle: 'CONTACTS',
        children: [
          {
            key: 'customers',
            label: 'customers',
            icon: CustomersSvg,
            path: PRIVATE_ROUTES.CUSTOMERS,
          },
          {
            key: 'suppliers',
            label: 'suppliers',
            icon: SuppliersSvg,
            path: PRIVATE_ROUTES.SUPPLIERS,
          },
          {
            key: 'subcontractors-mnt',
            label: 'subcontractors',
            icon: SubcontractosSvg,
            path: PRIVATE_ROUTES.SETTINGS,
            state: {
              tabKey: 'resources',
              subTabKey: ResourcePageEnum.SUBCONTRACTORS,
            },
          },
        ],
      },
      { key: 'invoicing', label: 'invoicing', icon: InvoicingSvg, path: PRIVATE_ROUTES.INVOICING },
      {
        key: 'credit-notes',
        label: 'creditNotes',
        icon: CreditNotesSvg,
        path: PRIVATE_ROUTES.CREDIT_NOTES,
      },
      { key: 'expenses', label: 'expenses', icon: ExpensesSvg, path: PRIVATE_ROUTES.EXPENSES },
    ],
  },

  {
    key: 'operations',
    label: 'operations',
    ui: 'accordion',
    icon: OperationsSvg,
    children: [
      { key: 'orders', label: 'orders', icon: OrdersSvg, path: PRIVATE_ROUTES.ORDERS },
      {
        key: 'dispatch-operation',
        label: 'dispatch',
        icon: DispatchSvg,
        path: PRIVATE_ROUTES.MOVING_DESPATCH,
      },
      { key: 'bookings', label: 'bookings', icon: BookingsSvg, path: PRIVATE_ROUTES.BOOKINGS },
      { key: 'shipments', label: 'shipments', icon: ShipmentsSvg, path: PRIVATE_ROUTES.SHIPMENTS },
      { key: 'claims', label: 'claims', icon: ClaimsSvg, path: PRIVATE_ROUTES.CLAIMS },
    ],
  },

  {
    key: 'warehousing',
    label: 'warehousing',
    ui: 'accordion',
    icon: WarehousingSvg,
    children: [
      {
        key: 'storage-boxes-units',
        label: 'storageBoxesAndUnits',
        icon: StorageBoxUnitSvg,
        path: PRIVATE_ROUTES.STORAGE_BOXES_UNITS,
      },
      { key: 'movement', label: 'movements', icon: MovementsSvg, path: PRIVATE_ROUTES.MOVEMENT },
      {
        key: 'transshipments',
        label: 'transshipment',
        icon: TransshipmentSvg,
        path: PRIVATE_ROUTES.TRANSSHIPMENTS,
      },
      {
        key: 'storage-accounts',
        label: 'storageAccount',
        icon: StorageAccountSvg,
        path: PRIVATE_ROUTES.STORAGE_ACCOUNTS,
      },
    ],
  },

  {
    key: 'reports',
    label: 'reports',
    ui: 'accordion',
    icon: ReportsSvg,
    children: [
      {
        key: 'favorites',
        label: 'favorites',
        icon: FavoritesSvg,
        path: PRIVATE_ROUTES.ANALYTICS,
        state: { reportsFilter: 'favorites' },
      },
      {
        key: 'management',
        label: 'management',
        icon: ManagementSvg,
        path: PRIVATE_ROUTES.ANALYTICS,
        state: { reportsFilter: 'management' },
      },
      {
        key: 'finance',
        label: 'finance',
        icon: FinanceSvg,
        path: PRIVATE_ROUTES.ANALYTICS,
        state: { reportsFilter: 'finance' },
      }, // TO DO: trocar p/ analytics quando pronto
      {
        key: 'business',
        label: 'business',
        icon: BussinesReportsSvg,
        path: PRIVATE_ROUTES.ANALYTICS,
        state: { reportsFilter: 'business' },
      },
      {
        key: 'operations',
        label: 'operations',
        icon: OperationsReportsSvg,
        path: PRIVATE_ROUTES.ANALYTICS,
        state: { reportsFilter: 'operations' },
      },
      {
        key: 'warehousing',
        label: 'warehousing',
        icon: WarehousingSvg,
        path: PRIVATE_ROUTES.ANALYTICS,
        state: { reportsFilter: 'warehousing' },
      },
    ],
  },

  { key: 'network', label: 'network', icon: NetworkSvg, path: PRIVATE_ROUTES.NETWORK },
];
